import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import HelpCenterLink from 'modules/core/components/HelpCenterLink'
import { HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'

import './index.styles.css'
interface Props {
  message: JSX.Element | string
  visibleLoader?: boolean
  alertColor?: React.ComponentProps<typeof Alert>['color']
  helpUrl?: HelpCenterUrl
  helpText?: string
  ariaLabel?: string
  id?: string
}

const MessageAlert = ({
  message,
  visibleLoader = true,
  alertColor = 'warning',
  helpUrl,
  helpText,
  id,
}: Props) => {
  return (
    <Alert color={alertColor}>
      <Box gap="s4" id={id}>
        <Box flexDirection="row" gap="s12" alignItems="center">
          {visibleLoader && (
            <Box className={'MessageAlert_spin'}>
              <Icon.Medium icon="spinner" color="grey800" />
            </Box>
          )}
          <Text size="300" color="grey1000">
            {message}
          </Text>
        </Box>
        {helpUrl && (
          <Box flexDirection="row">
            <HelpCenterLink name={helpUrl} type="solid">
              {helpText}
            </HelpCenterLink>
          </Box>
        )}
      </Box>
    </Alert>
  )
}

export default MessageAlert
